import { breakpoints, Dialog, Margin, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { AddAccountForm } from './AddAccountForm'

const DialogContentWrapper = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
    padding: ${Margin.Small};
    width: 500px;
    form {
        width: 100%;
    }

    ${breakpoints.xsmall} {
        width: auto;
    }
`

interface AddAccountDialogProps {
    open: boolean
    onClose: () => void
    payOthers?: boolean
}

export const AddAccountDialog: React.VFC<AddAccountDialogProps> = ({
    open,
    onClose,
    payOthers,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <Dialog.Content contentPadding={false}>
                <Dialog.Title>Add a bank account</Dialog.Title>
                <Spacer height={24} />
                <DialogContentWrapper>
                    <AddAccountForm onComplete={onClose} payOthers={payOthers} />
                    <Spacer height={16} />
                </DialogContentWrapper>
            </Dialog.Content>
        </Dialog>
    )
}
